/*
 * Shared display formatters.
 */

/**
 * Format an ISO-8601 timestamp as `YYYY-MM-DD HH:MM` in 24-hour LOCAL time —
 * the single date/time format used across the app (Queue, Run detail,
 * Credentials, …). Invalid input is returned unchanged so a bad value stays
 * visible rather than rendering "Invalid Date".
 */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = (n: number): string => String(n).padStart(2, "0");
  return (
    `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ` +
    `${p(d.getHours())}:${p(d.getMinutes())}`
  );
}
